module.exports = __webpack_public_path__ + "static/media/mode-50.00dddd0a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Containers/Workspace/Tools/GgbIcons/mode-50.svg
// module id = 1004
// module chunks = 2